export const history = {
  navigate: null,
  location: null
};

export const getRoute = ()=>{
  // const outsideAuth = ["login","loginbyvrnscreen","responsescreen","activateuser","unlockuserscreen","selectunlockscreen","checktagbalance","selectforgotscreen","forgotuserscreen","forgotpasswordscreen"]
  // let route = {...global?.initialRoute} || "/Home"
  // console.log("route res",route)
  // route = route.slice(1)
  // if(outsideAuth.includes(route.toLowerCase())){
  //   console.log("route res1",route)
  //   route = "Home"  
  // } 
  // console.log("route res",route)
  // return routes
};